import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { addProject } from '../actions/projects'

const AddProject = ({ firebase, auth }) => {
  let name, rate

  return (
    <div>
    <h2>Add Project</h2>
      <form
        onSubmit={e => {
          e.preventDefault()
          if (!name.value.trim()) {
            return
          }
          firebase.push(`projects/${auth.uid}`, addProject({name: name.value, rate: rate.value }))
          name.value = ''
          rate.value = ''
        }}
      >
        <label htmlFor='project-name'>Name: <input id='project-name' ref={node => name = node} /></label>
        <br />
        <label htmlFor='project-rate'>Rate<input id='project-rate' ref={node => rate = node} /></label>
        <br />
        <button type='submit' className='button'>
          Add Project
        </button>
      </form>
    </div>
  )
}

AddProject.propTypes = {
  auth: PropTypes.shape({
    uid: PropTypes.string.isRequired
  }),
  firebase: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
}

const enhance = compose(
  firebaseConnect(['projects']),
  connect(
    ({ firebase: { auth, data: { projects }} }) => ({
      projects,
      auth
    })
  )
)

export default enhance(AddProject)


// WEBPACK FOOTER //
// ./src/containers/AddProject.js